import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidGlassMartiniAltIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="m16.6 10.1 5.2-6.5c.3-.4.3-1.1-.2-1.4-.2-.1-.4-.2-.6-.2H3c-.6 0-1 .4-1 1 0 .2.1.4.2.6l5.2 6.5 3.6 4.5V20H5.2c-.6 0-1 .4-1 1s.4 1 1 1h13.5c.6 0 1-.4 1-1s-.4-1-1-1H13v-5.4l3.6-4.5ZM7.5 7 5.1 4h13.8l-2.4 3h-9Z"/>
  </SvgIcon>
}

export default SolidGlassMartiniAltIcon
